export class LineOfBusiness{
    public LOBCode: string;
    public LOBName: string;
    public LOBEffectiveDate: Date;
    public LobDisplayText: string;
}